import { createFileRoute } from '@tanstack/react-router';

import { legalPersonDetailScreen, loadPersonMessages, loadPersonScreens, personDetailSearch } from '@/modules/person/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute('/_app/pessoas-juridicas/todas/$personId/')({
  validateSearch: personDetailSearch,
  staticData: { screen: legalPersonDetailScreen },
  loader: () => loadPersonMessages(),
  component: lazyScreen(loadPersonScreens, 'LegalPersonDetailPage'),
});
